import React from "react";

const Refresh = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.86732 11.6189C5.08693 11.6189 4.35597 11.4706 3.67443 11.1741C2.9929 10.8776 2.3998 10.477 1.89515 9.9723C1.3905 9.46765 0.989903 8.87456 0.693356 8.19302C0.396809 7.51148 0.248535 6.78052 0.248535 6.00013C0.248535 5.21975 0.396809 4.48878 0.693356 3.80725C0.989903 3.12571 1.3905 2.53261 1.89515 2.02796C2.3998 1.52331 2.9929 1.12272 3.67443 0.826168C4.35597 0.529621 5.08693 0.381348 5.86732 0.381348C6.72054 0.381348 7.52954 0.563438 8.29432 0.927618C9.0591 1.2918 9.70682 1.80685 10.2375 2.47278V1.00566H11.4861V4.75151H7.74025V3.50289H9.4571C9.03049 2.92021 8.50503 2.46238 7.88072 2.12941C7.25641 1.79645 6.58528 1.62997 5.86732 1.62997C4.64992 1.62997 3.6172 2.05398 2.76918 2.902C1.92116 3.75002 1.49715 4.78273 1.49715 6.00013C1.49715 7.21754 1.92116 8.25025 2.76918 9.09827C3.6172 9.94629 4.64992 10.3703 5.86732 10.3703C6.95986 10.3703 7.91454 10.0165 8.73134 9.30897C9.54814 8.60142 10.0294 7.70658 10.1751 6.62444H11.4549C11.2988 8.04995 10.6875 9.23874 9.62098 10.1908C8.55445 11.1429 7.30323 11.6189 5.86732 11.6189ZM7.61539 8.62223L5.24301 6.24986V2.87859H6.49163V5.75041L8.48942 7.7482L7.61539 8.62223Z"
        fill="#F2F8ED"
      />
    </svg>
  );
};

export default Refresh;
